import { PageDescription } from '@/shared/components';
import RegRequestsTable from './components/RegRequestsTable/RegRequestsTable';
import './index.css';

function RequestsPage() {
  return (
    <>
      <div className='RequestsPageWrapper'>
        <PageDescription title={'Запросы'} />
        <RegRequestsTable />
      </div>
    </>
  );
}

export default RequestsPage;
